
<template>
  <div class="header_franchise">
    <div class="franchise_nav_container">
      <div class="franchise_nav_box">
        <router-link tag="div" :to="'/franchise'" class="franchise_nav_btn">
          <div class="link_description">
            <h1>Информация по франчайзингу</h1>
          </div>
          <div class="arrow_box"></div>
        </router-link>
        <router-link tag="div" :to="'/saas'" class="franchise_nav_btn">
          <div class="link_description">
            <h1>Создадим для вас собственный агрегатор</h1>
            <p>SaaS решения</p>
          </div>
          <div class="arrow_box"></div>
        </router-link>
        <router-link tag="div" :to="'/investment'" class="franchise_nav_btn">
          <div class="link_description">
            <h1>Инвестировать в открытие</h1>
            <p>Без участия в управлении</p>
          </div>
          <div class="arrow_box"></div>
        </router-link>
        <router-link tag="div" :to="'/white_label'" class="franchise_nav_btn">
          <div class="link_description">
            <h1>Есть свой сайт? Зарабатывайте на доставке без вложений</h1>
            <p>White label</p>
          </div>
          <div class="arrow_box"></div>
        </router-link>
      </div>
    </div>
    <div class="container">
      <div class="header_franchise_box">
        <!--div class="points_box">
          <div class="point">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
            <span>Управляйте бизнесом из дома – офис и персонал Вам не нужен</span>
          </div>
          <div class="point">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
            <span>Без вложений</span>
          </div>
          <div class="point">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
            <span>Один город – одна франшиза</span>
          </div>
          <div class="point">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
            <span>Настоящий интернет-бизнес</span>
          </div>
          <div class="point">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
            <span>Всего 3 часа в день на работу</span>
          </div>
          <div class="point">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
            <span>Мы не доставляем. Все делают рестораны</span>
          </div>
          <div class="point">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/green_point.svg" alt="">
            <span>Вы станете партнером национальной сети по доставке еды из ресторанов Вашего города</span>
          </div>
        </div-->
        <div class="points_box">
          <div class="point">
            <img src="https://xn----jtbzbeohcqv6d.xn--j1amh/static/img/franchise/green_point.svg" alt="">
            <span>Управляйте бизнесом из дома – офис и персонал Вам не нужен</span>
          </div>
          <div class="point">
            <img src="https://xn----jtbzbeohcqv6d.xn--j1amh/static/img/franchise/green_point.svg" alt="">
            <span>Все % от ресторанов остаются у Вас</span>
          </div>
          <div class="point">
            <img src="https://xn----jtbzbeohcqv6d.xn--j1amh/static/img/franchise/green_point.svg" alt="">
            <span>Нет взноса и роялти</span>
          </div>
          <div class="point">
            <img src="https://xn----jtbzbeohcqv6d.xn--j1amh/static/img/franchise/green_point.svg" alt="">
            <span>Настоящий интернет-бизнес</span>
          </div>
          <div class="point">
            <img src="https://xn----jtbzbeohcqv6d.xn--j1amh/static/img/franchise/green_point.svg" alt="">
            <span>Всего 3 часа в день на работу</span>
          </div>
          <div class="point">
            <img src="https://xn----jtbzbeohcqv6d.xn--j1amh/static/img/franchise/green_point.svg" alt="">
            <span>Можете вносить любые изменения в IT</span>
          </div>
          <!--div class="point">
            <img src="https://xn----jtbzbeohcqv6d.xn--j1amh/static/img/franchise/green_point.svg" alt="">
            <span>Вы станете партнером национальной сети по доставке еды из ресторанов Вашего города</span>
          </div-->
        </div>
        <div class="steps_box">
          <h1>БИЗНЕС В 4 ШАГА</h1>
          <div class="step">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/dish.svg" alt="">
            <p>заключаете договоры с ресторанами</p>
          </div>
          <div class="step">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/doc.svg" alt="">
            <p>продвигаете сервис в своём городе</p>
          </div>
          <div class="step">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/graph.svg" alt="">
            <p>люди заказывают еду через наш сайт</p>
          </div>
          <div class="step">
            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/rub.svg" alt="">
            <p>каждый час вы получаете процент с каждого заказа</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'franchiseNav',
  data () {
    return {
      page: 'index'
    }
  },
  created () {
    this.page = this.$route.name
  },
  watch: {
    $route (to, from) {
      this.page = to.name
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/franchiseNav.vue